import { Injectable } from '@angular/core';
import { BazisDocumentService } from '@bazis/shared/services/document.service';
import { DocusignSigningComponent } from '@bazis/signature/docusign/components/signing/signing.component';
import { NCALayerSigningComponent } from '@bazis/signature/ncalayer/components/signing/signing.component';
import { TMSCryptoSigningComponent } from '@shared/components/signature/crypto/signing/signing.component';

@Injectable({
    providedIn: 'root',
})
export class DocumentService extends BazisDocumentService {
    signingComponents = {
        crypto: TMSCryptoSigningComponent,
        docusign: DocusignSigningComponent,
        NCALayer: NCALayerSigningComponent,
    };

    skipDefaultErrorToast = true;
}
